import AddBookingTab from "./sub_tabs/AddBookingTab";
import AuditionBookingsTab from "./sub_tabs/AuditionBookingsTab";
import ViewAuditioneesTab from "./sub_tabs/ViewAuditioneesTab";

const auditionsRouter = {

  auditions: 
  {
    title: 'Bookings',
    element: <AuditionBookingsTab />
  },

  add_unbooked_audition: 
  {
    title: 'Add Booking',
    element: <AddBookingTab />
  },

  list_auditionees:
  {
    title: 'List',
    element: <ViewAuditioneesTab />
  }

}

export default auditionsRouter;